module.exports = __webpack_public_path__ + "static/media/mock-up3.d68e9585.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/mock-up3.png
// module id = 506
// module chunks = 0